import {Component, inject, Input, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {faChevronRight, faXmark} from "@fortawesome/pro-solid-svg-icons";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

import {StateConfigService} from "../../../services/state/state-config.service";
import {AllInCheckNavigationService} from "../../../services/checks/all-in-check-navigation.service";
import {QualityRulesPrefetchService} from "../../../services/prefetch/quality-rules-prefetch.service";
import {FilePrefetchService} from "../../../services/prefetch/file-prefetch.service";


@Component({
  selector: 'call-to-action-banner',
  templateUrl: './call-to-action-banner.component.html',
  styleUrl: './call-to-action-banner.component.scss',
  imports: [
    FaIconComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class CallToActionBannerComponent {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private stateConfigService = inject(StateConfigService);
  private allInCheckNavigation = inject(AllInCheckNavigationService);
  private qualityRulesPrefetchService = inject(QualityRulesPrefetchService);
  private filePrefetchService = inject(FilePrefetchService);


  @Input() title = "";
  @Input() descr = "";
  @Input() button = "";
  @Input() unsubscriber = false;

  pressedX = false;

  public pressX() {
    this.pressedX = true;
  }

  protected buttonText() {
    // Extend this for other buttons
    switch (this.button) {
      case "BIM":
        return "LOIplus-Check"
      case "HOAI":
        return "HOAI-Check"
      case "QUALITY":
        return "All-Right-Check"
      // More cases here
    }
    return "";
  }

  protected routeTo() {
    // Extend this for other routes
    this.filePrefetchService.prefetch();
    switch (this.button) {
      case "BIM":
        this.allInCheckNavigation.startLoiplusCheck();
        break;
      case "HOAI":
        this.allInCheckNavigation.startHoaiCheck();
        break;
      case "QUALITY":
        this.qualityRulesPrefetchService.prefetch();
        this.router.navigateByUrl('/projects/' + this.stateConfigService.getProjectId() + '/quality/rules')
        break;
      // More cases here
    }
  }

  protected readonly faXmark = faXmark;
  protected readonly faChevronRight = faChevronRight;




}
